<div class="modal-messages">
  <div class="message lifeislife-message-box severity-colored" *ngFor="let m of messages$ | async"
       [@messageIn]="'in'"
       [ngClass]="m.severity"
       (click)="onMessageClick(m)"
  >
    <div class="summary">{{m.summary}}</div>
    <div class="details">{{m.detail}}</div>
    <div *ngIf="m.severity === 'error'">
      Si le problème persiste, contactez-nous directement par email ầ <a href="mailto:info@lifeislife.be"
                                                                         (click)="$event.stopImmediatePropagation()">
      info@lifeislife.be
    </a>.
    </div>
  </div>
</div>
